import React, { Component } from 'react'
import { withTranslation } from 'react-i18next' // eslint-disable-line

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'

import { WithTranslation } from '../../../types'
import {
   ButtonContainer,
   Container,
   Content,
   FailureText
} from './styledComponents'

interface FailureViewProps extends WithTranslation {
   onRetry: () => any
   failureText: string
}

class FailureView extends Component<FailureViewProps> {
   render() {
      const { onRetry, failureText, t } = this.props
      return (
         <Container>
            <Content>
               <FailureText>{failureText}</FailureText>
            </Content>
            <ButtonContainer>
               <Button
                  hierarchy={Hierarchy.Primary}
                  subVariant={SubVariant.Primary}
                  size={'Small'}
                  className={'create-graph-next-button'}
                  onClick={onRetry}
               >
                  {t('common:failureView.retry')}
               </Button>
            </ButtonContainer>
         </Container>
      )
   }
}

export default withTranslation()(FailureView)
